<template>
  <div>
    <ol class="progress">
      <li
        :class="['step', indexNum === index ? 'active' : '']"
        v-for="(item, index) in stepList"
        :key="getName(item)"
      >
        <i>{{ indexNum > index ? "&#10003;" : index + 1 }}</i>
        <div class="main">
          <div class="name">
            {{ getName(item) }}
          </div>
          <div class="time" v-if="item.time">
            {{ item.time }}
          </div>
        </div>
        <div class="arrow" />
      </li>
    </ol>
  </div>
</template>

<script>
export default {
  name: "ProgressPurchase",
  props: {
    activeIndex: {
      type: [Number, String],
      default: 0
    }
    // stepList: {
    //   type: Array,
    //   default() {
    //     return [];
    //   },
    // },
  },
  computed: {
    stepList() {
      // 填写投保信息
      if (this.activeIndex == 0) {
        this.indexNum = 0;
        return ["资料填报", "资料审核", "支付费用", "投保成功"];
      }
      //   审核中
      if (this.activeIndex == 1) {
        this.indexNum = 1;
        return ["资料填报", "资料审核", "支付费用", "投保成功"];
      }
      //   审核失败
      if (this.activeIndex == 2) {
        this.indexNum = 1;
        return ["资料填报", "资料审核", "支付费用", "投保成功"];
      }
      //  待支付
      if (this.activeIndex == 4) {
        this.indexNum = 2;
        return ["填写投保信息", "投保审核", "待支付", "投保成功"];
      }
      //支付审核
      if (this.activeIndex == 5||this.activeIndex == 6||this.activeIndex == 7||this.activeIndex == 88||this.activeIndex == 99) {
        this.indexNum = 2;
        return ["填写投保信息", "投保审核", "支付审核", "投保成功"];
      }
      //  出函中
      if (this.activeIndex == 8) {
        this.indexNum = 2;
        return ["填写投保信息", "投保审核", "支付完成", "投保成功"];
      }
      //  出函成功
      if (this.activeIndex == 3) {
        this.indexNum = 3;
        return ["填写投保信息", "投保审核", "支付完成", "投保成功"];
      }

      // // 已支付
      // if (this.activeIndex == 14) {
      //   this.indexNum = 2;
      //   return ["填写投保信息", "投保审核", "支付完成", "投保成功"];
      // }
      // // 投保成功
      // if (this.activeIndex == 21) {
      //   this.indexNum = 3;
      //   return ["填写投保信息", "投保审核", "支付完成", "投保成功"];
      // }
      // // 提交退保
      // if (this.activeIndex == 31) {
      //   this.indexNum = 0;
      //   return ["提交退保", "退保成功"];
      // }
      // // 退保成功
      // if (this.activeIndex == 33) {
      //   this.indexNum = 1;
      //   return ["提交退保", "退保成功"];
      // }

      // // 退保失败
      // if (this.activeIndex == 32) {
      //   this.indexNum = 1;
      //   return ["提交退保", "退保失败"];
      // }
    }
  },
  data() {
    return {
      indexNum: 0
    };
  },
  mounted() {
    console.log(this.activeIndex);
  },
  methods: {
    getName(item) {
      return typeof item === "object" ? item.name : item;
    }
  }
};
</script>

<style lang="less" scope>
.progress {
  overflow: hidden;
  border-bottom: 1px solid #f0f0f0;
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  background-color: #fff;
  .step {
    flex: 1;
    padding: 17px 0;
    position: relative;
    text-align: center;
    box-sizing: border-box;
    i {
      display: inline-block;
      width: 36px;
      background: #ffffff;
      border: 2px solid #007ce2;
      border-radius: 50%;
      font-style: normal;
      font-size: 24px;
      color: #007ce2;
      line-height: 36px;
      box-sizing: content-box;
      vertical-align: middle;
    }
    .main {
      margin-left: 25px;
      display: inline-block;
      vertical-align: middle;
      text-align: left;
      .name {
        font-size: 16px;
        color: #333;
      }
      .time {
        margin-top: 3px;
        font-size: 12px;
        color: #999;
      }
    }
    .arrow,
    .arrow::after {
      width: 0;
      height: 0;
      border-top: 42px solid transparent;
      border-left: 15px solid #eaeaea;
      border-bottom: 42px solid transparent;
    }
    .arrow {
      position: absolute;
      left: 0;
      top: -5px;
      &::after {
        position: absolute;
        left: -17px;
        top: -42px;
        content: " ";
        border-left-color: #fff;
      }
    }
    &:first-child .arrow {
      display: none;
    }
  }
  .step.active {
    background: linear-gradient(to right, rgba(0, 124, 226, 0.1) 50%, #fff 70%);
    &:first-child {
      border-left: 2px solid #007ce2;
    }
    i {
      position: relative;
      background-color: #007ce2;
      color: #fff;
      &::after {
        position: absolute;
        right: -7px;
        top: 12px;
        content: " ";
        border-top: 7px solid transparent;
        border-left: 7px solid #007ce2;
        border-bottom: 7px solid transparent;
      }
    }
    .arrow {
      border-left: 15px solid #007ce2;
    }
    // & + .step{
    //   .arrow{
    //     border-left: 15px solid #007CE2;
    //   }
    // }
  }
}
</style>
